<template>
  <v-container>
    <v-row wrap>
      <div class="col-12 col-xs-12">
        <v-file-input
          :label="$t('components.portal.image_uploader.file')"
          v-on:change="handleFileChange"
          v-model="file"
        ></v-file-input>
      </div>

      <div
        class="col-12 col-xs-12"
        v-if="fileItem !== null && fileItem !== undefined"
      >
        <pdf-preview
          v-if="fileItem.FileExtension.toLowerCase() === 'pdf'"
          :fileItem="fileItem"
        />

        <v-img
          v-else-if="
            fileItem.FileExtension.toLowerCase() === 'png' ||
              fileItem.FileExtension.toLowerCase() === 'jpg' ||
              fileItem.FileExtension.toLowerCase() === 'jpeg'
          "
          :src="'data:image/jpg;base64,' + fileItem.Base64"
        ></v-img>

        <span
          v-else-if="fileItem.FileExtension.toLowerCase() === 'txt'"
          class="file-preview-container"
          style="font-size: 1em; overflow-y: auto"
        >
          {{ formatBase64ToText(fileItem.Base64) }}
        </span>
      </div>
      <v-card-text v-else class="file-preview-container">
        <h5 class="white--text">
          {{ $t("components.filepreview.no_preview") }}
        </h5>
      </v-card-text>
    </v-row>
    <v-card-actions>
      <v-btn
        color="primary"
        @click="submitFile"
        :disabled="!file"
        :loading="saving"
      >
        {{ $t("globals.upload") }}
      </v-btn>
    </v-card-actions>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ApiService from "@/services/api.service";
import PdfPreview from "@/components/Claims/PdfPreview.vue";
export default {
  components: {
    PdfPreview,
  },
  data: () => ({
    file: undefined,
    fileItem: undefined,
    saving: false,
  }),
  computed: {
    ...mapGetters("common", ["settings"]),
    ...mapGetters("plansMembers", ["planIdentity"]),
  },
  methods: {
    ...mapActions("downloadCenter", ["saveIcon"]),
    getExtension(name) {
      const parts = name.split(".");
      if (parts.length > 0) {
        return parts[parts.length - 1];
      }
      return null;
    },
    readFileAsDataUrlAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },
    async handleFileChange(file) {
      if (!file) {
        this.file = undefined;
        this.$emit("clear");
        return;
      }
      this.file = file;
      // console.log(file);
      this.fileItem = {
        Base64: this.getBase64(await this.readFileAsDataUrlAsync(file)),
        FileName: file.name,
        FileExtension: this.getExtension(file.name),
      };
      // console.log(this.fileItem);
    },
    getBase64(base64) {
      let index = base64.search("base64,");
      return base64.substring(index + "base64,".length);
    },
    async submitFile() {
      this.$emit("upload-started");
      this.saving = true;
      try {
        const res = await this.postFile();
        this.$emit("upload-completed", res.data);
      } catch (error) {
        // console.log(error);
        this.$emit("upload-error", error);
      } finally {
        this.saving = false;
      }
    },
    postFile() {
      let formData = new FormData();
      formData.append("files", this.file);
      const url = `${this.settings.DOCUMENTSERVICEURL}Api/UploadFilesFormData/${this.planIdentity.UniqueIdentifier}_portal`;
      return ApiService.postFile(url, formData);
    },
    formatBase64ToText(base64Txt) {
      return atob(base64Txt);
    },
  },
};
</script>
<style></style>
